import request from "@/utils/request";

export default function agentGetQrCodeList(deviceId) {
    return request({
        url: `/device/qrcode/agentGetQrCodeList/${deviceId}`
    })
}